import type { Normalizer } from '@change-corgi/core/fcm';

export const normalizeSafelist: Normalizer<string[]> = (safelist: unknown) => {
	if (!safelist || !Array.isArray(safelist) || safelist.some((val) => !(typeof val === 'string'))) {
		throw new Error('Invalid safelist returned from FCM');
	}
	return safelist as string[];
};
